var React = require('react');

function IcoPickup (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M31.82 17.5A17.5 17.5 0 1114.32 35a17.52 17.52 0 0117.5-17.5m0-7A24.5 24.5 0 1056.32 35a24.5 24.5 0 00-24.5-24.5z","fill":"#c4c4c4"}));
}

IcoPickup.defaultProps = {"data-name":"Layer 1","viewBox":"0 0 63.64 70"};

module.exports = IcoPickup;

IcoPickup.default = IcoPickup;
